<!--
 * @Author: your name
 * @Date: 2021-05-25 17:16:46
 * @LastEditTime: 2021-09-06 18:54:02
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \epec-mall\components\common\header.vue
-->
<template>
  <header>
    <div class="header_wrapper">
      <div class="header-search-wrap">
      <div class="header_middle ">
        <div class="middle_left pointer">
          <div class="flex zoon-info" v-if="logoImg">
             <img class="zoon-img" :src="logoImg" alt="" height="100%" />
          </div>
          <p class="line"></p>
          <div class="shop_name">
             <img src="@/assets/img/exclusivePurchase/shop_icon.png" alt="">
             <p class="name"><span>{{mallName==''?'采购专属商城':mallName}}</span></p>
          </div>
 
        </div>
        <div class="middle_right">
            <div class="flex middle_search">
              <el-input class="middle_input" size="middle" v-model="searchValue" placeholder="搜索您想要的商品、供应商"></el-input>
              <p   class="middle_btn">搜本站</p>
            </div>
            <div   class="btn_item flex" :style="{width:item.width}"  v-for="item in btnList" :key="item.value" :class="{active:(item.value==activepage)}">
              <p v-if="item.value==1"><img :src="activepage==1?item.img1:item.img" alt="" width="17px" height="17px"></p>
              <p v-if="item.value==2"><img :src="activepage==2?item.img1:item.img" alt="" width="17px" height="17px"></p>
              <p>{{item.title}}</p>
            </div>
        </div>
      </div>
 
      </div>
    </div>
 
  </header>
</template>
<script>
 

export default {
   props:{
      logoImg:{
          type: String,
            default: () => {
              return '';
            },
      },
      mallName:{
          type: String,
            default: () => {
              return '';
            },
      },
      activepage:{
          type: Number,
          default: () => {
            return 2;
          },
      }
    },
  components:{
    
  },
  data() {
    return {
      activeIndex: "3",
      searchValue: "", //搜索词
      btnList:[{
        value:1,
        title:'工作台',
        img:require('@/assets/img/exclusivePurchase/icon1.png'),
        img1:require('@/assets/img/exclusivePurchase/icon1_1.png'),
        width:'128px',
        active:1
      },
      {
        value:2,
        title:'企业商城',
        img:require('@/assets/img/exclusivePurchase/icon2.png'),
        img1:require('@/assets/img/exclusivePurchase/icon2_1.png'),
        active:2,
        width:'148px',
      }]
    };
  },
 
  methods: {
     
    
  },
};
</script>
<style lang="scss" scoped>  
.header_wrapper {
  position: relative;
  .header-search-wrap{
    background: #FFFFFF;
    box-shadow: 0px 3px 4px rgba(163, 163, 163, 0.25);
  }
  .header_top {
    width: 100%;
    height: 30px;
    background: #163b6d;
    .top_content {
      width: 1200px;
      margin: 0 auto;
      line-height: 30px;
      .site_kefu {
        color: #fdb900;
        font-size: 16px;
        cursor: pointer;
      }
    }
  }

  .header_middle {
    width: 1200px;
    margin: 0 auto;
    height: 80px;
    align-items: center;
    display: flex;
    justify-content: space-between;
    .middle_left {
 
      align-items: center;
      display: flex;
     

      .zoon-info{
        align-items: center;
       
        .zoon-img{
          max-width: 200px;
          height: 50px;
        }
        .zoon-name{
          background: linear-gradient(174.77deg, #F0D1AC 4.19%, #C89E5C 137.77%);
 
          border-radius: 3px; 
          font-size: 14px;
          color:#825200;
          padding:0 10px;
          margin-left: 20px;
          height: 35px;
          line-height: 35px;
          img{
            width:14px;
            height:13px;
          }
 
        }
        
      }
      .line{
        width:1px;
        height: 34px;
        background: #333333;
        margin:0 10px;
      }
      .shop_name{
        display: flex;
       
        img{
          width:40px;
          height:40px;
        }
        .name{
          color: #8B5800;
          font-weight: 500;
          font-size: 18px;
          height:40px;
          background: url('../../../../assets/img/exclusivePurchase/shop_line.png');
          background-repeat: repeat-x;
          padding:0 8px 0 8px;
          border-radius:  0px 4px 4px 0px;
          span{
            margin-top: 8px;
            display: inline-block;
          }
        }
      }
    }
    .middle_right {
        display: flex;
        .middle_search{
          margin-right: 30px;
        }
 
        .middle_input {
          width: 323px;
          ::v-deep.el-input__inner {
            border: 1px solid #2587ff;
            border-right: none;
            border-radius: 0;
          }
        }
        .middle_btn {
          width: 70px;
          height: 40px;
          line-height: 40px;
          color: #2587ff;
          text-align: center;
          cursor: pointer;
          border:1px solid #2587ff;
          background: #fff;
          
        }
        .middle_btn:hover{
          background:  #2587ff;
          color:#fff;
          border:none;
        }
        .btn_item{
          color:#2587ff;
          // width: 128px;
          align-items: center;
          border:1px solid #2587ff;
          justify-content: center;
          font-size: 20px;
          margin-right: 8px;
          cursor: pointer;
          
          img{
            margin-right: 10px;
          }
          
        }
        .active{
          background:#2587ff;
          color:#fff;
        }
        
    }
  }

  .header_bottom {
    width: 1200px;
    margin: 0 auto;
    z-index: 9;
    .bottom_sort {
      background: #2587ff;
      width: 220px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 16px;
      color: #fff;
    }
    .bottom_menu {
      line-height: 40px;
      // padding: 0 20px;
    }
  }
  .box_solid {
    position: absolute;
    bottom: 0;
    height: 2px;
    width: 100%;
    background: #2587ff;
  }
}

.my_dropdown {
  .el-dropdown {
    cursor: pointer;
    color: #fff;
    margin-right: 24px;
    font-size: 12px;
    ::v-deep.el-dropdown-link {
      .site_language {
        width: 21px;
        height: 14px;
        vertical-align: middle;
      }
      .site_phone {
        color: #fdb900;
      }
    }
  }
}
.my_menu {
  border-bottom: none;
  ::v-deep.el-submenu {
    line-height: 40px;
    height: 40px;
    .el-submenu__title {
      line-height: 40px;
      height: 40px;
    }
  }
  ::v-deep.el-menu-item {
    line-height: 40px;
    height: 40px;
  }
  ::v-deep.el-menu-item.is-active {
    z-index: 9;
  }
  ::v-deep.el-submenu.is-active .el-submenu__title {
    z-index: 9;
  }
} 
.login-status {
  display: flex;
  .login-txt {
    position: relative;
    color: #fff;
    font-size: 12px;
    margin-right: 10px;
    .icon-arrow {
      width: 8px;
      height: 5px;
    }
  }
  .userInfo {
    z-index: 1000;
    width: 315px;
    position: absolute;
    background: #fff;
  }
}
.header-line{
  height: 1px ;
  width: 100%;
  background:  #D9D9D9;
  margin-bottom:10px;
}
</style>